import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  // VideoObject structured data
  const videoStructuredData = createVideoStructuredData({
    networkName: 'Space City Home Network',
    callsign: 'ATTSWHD',
    logoUrl: networkLogos.spacecity.logoUrl,
    slug: 'space-city-home-network',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="ATTSWHD"
        title="Space City Home Network Live with Fubo"
        networkName="Space City Home Network"
        customNetworks={['spacecity']}
      />
    </>
  )
}
